<template>
  <KycCommonHeader :title="$t('kyc.onboarding')" @go-back="$router.back()" showLocale />
  <section class="tw-mt-10 md:tw-mt-2 tw-flex tw-justify-center">
    <div
      class="tw-py-12 tw-px-5  tw-text-center tw-card tw-bg-[#FAFAFB] md:tw-bg-transparent tw-rounded-2xl tw-w-full tw-max-w-screen-md">
      <div class="tw-flex tw-flex-col tw-gap-10 tw-items-center">

        <div class="tw-flex tw-flex-col tw-justify-center tw-gap-6 tw-max-w-sm tw-w-full">

          <div class=" tw-flex tw-flex-col tw-items-start tw-justify-start tw-text-left">
            <p
              class="tw-leading-tight md:!tw-leading-loose tw-text-base md:tw-text-lg lg:tw-text-xl tw-font-bold tw-mb-2">
              {{ $t('Account Type') }}</p>
            <div class=" tw-flex tw-justify-start tw-gap-5 tw-w-full">
              <div class="tw-form-control tw-flex-1">
                <button class="tw-border tw-input-bordered tw-px-3 tw-py-1.5 md:tw-py-0.5 tw-rounded-md hover:tw-border-primary" :class="{
                  'tw-border-primary': accountType === '0'
                }">
                  <label class="tw-label tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-gap-4">
                    <span class=" tw-text-base tw-font-normal">{{ $t('kyc.individual') }}</span>
                    <input type="radio" name="radio-10" class="tw-radio" :class="{
                      'tw-radio-success': accountType === '0'
                    }" value="0" v-model="accountType" />
                  </label>
                </button>


              </div>
              <div class="tw-form-control tw-flex-1">
                <button class="tw-border tw-input-bordered tw-px-3 tw-py-1.5 md:tw-py-0.5 tw-rounded-md hover:tw-border-primary" :class="{
                  'tw-border-primary': accountType === '1'
                }">
                  <label class="tw-label tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-gap-4">
                    <span class="tw-text-base tw-font-normal">{{ $t('kyc.institution') }}</span>
                    <input type="radio" name="radio-10" class="tw-radio " :class="{
                      'tw-radio-success': accountType === '1'
                    }" value="1" v-model="accountType" />
                  </label>
                </button>
              </div>
            </div>
          </div>
          <div class=" tw-flex tw-flex-col tw-items-start tw-justify-start tw-text-left">
            <p
              class="tw-leading-tight md:!tw-leading-loose tw-text-base md:tw-text-lg lg:tw-text-xl tw-font-bold tw-mb-2 md:tw-mb-1">
              {{ $t('Country') }} </p>
            <p class=" tw-mb-2 tw-text-sm md:tw-text-base tw-leading-normal md:tw-leading-relaxed">{{ countryTip }}</p>
            <UICountry v-model="country" :placeholder="$t('kyc.select_country')" isGuest />
          </div>


          <div class=" tw-flex tw-justify-center tw-items-center tw-mt-10">
            <UIButton :disabled="!country || !accountType"
              class="tw-btn tw-rounded-none tw-btn-xl tw-text-neutral tw-border-neutral tw-border-2 tw-w-[190px] hover:tw-bg-neutral/10"
              @click="kycType()">
              {{ $t('Continue') }}</UIButton>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
const { t } = useI18n()
const localeRoute = useLocaleRoute()
const route = useRoute()
const accountType = ref('0')
const country = ref();
const loading = ref(false)
const { setUsed, getUsed } = useSession()
const kycType = async function () {
  const $meta = document.querySelector('meta[name=sign]')
  if (getUsed()) {
    loading.value = true
    const data: { sign?: string } = await $fetch('/api/google-recaptcha/sign', {
      method: 'POST',
    })
    loading.value = false
    if (data.sign) {
      $meta?.setAttribute('content', data.sign)
      setUsed(false)
    }
  }

  const _route = localeRoute({ name: 'kyc', query: { ...route.query, state: `1${accountType.value}`, region: country.value } })
  if (_route) {
    return navigateTo(_route.fullPath)
  }
}
const countryTip = computed(() => {
  // if (!accountType.value) return t('account_type_country_tip[0]')
  return accountType.value === '1' ? t('account_type_country_tip[1]') : t('account_type_country_tip[2]')
})
</script>
